import { channelConfig } from '@finn-no/adboost/channels';

const balls = [
    { name: 'adboost' },
    { name: 'schibsted' },
    { name: 'adressa.no' },
    { name: 'aftenbladet.no' },
    { name: 'altaposten' },
    { name: 'andalsnes-avis' },
    { name: 'ap.no' },
    { name: 'aftenposten.no' },
    { name: 'avisast' },
    { name: 'banett' },
    { name: 'bladet' },
    { name: 'bt.no' },
    { name: 'dolen' },
    { name: 'driva' },
    { name: 'e24' },
    { name: 'facebook' },
    { name: 'instagram' },

    { name: 'fjordingen' },
    { name: 'fjordabladet' },
    { name: 'fjt' },
    { name: 'fjuken' },
    { name: 'folkebladet' },
    { name: 'fosnafolket' },
    { name: 'framtidinord' },
    { name: 'firdatidend' },
    { name: 'fvn.no' },
    { name: 'hitrafroya' },
    { name: 'ht' },
    { name: 'innherred' },
    { name: 'itromso' },
    { name: 'morenytt' },
    { name: 'opp' },
    { name: 'rbnett' },
    { name: 'smp' },
    { name: 'nyss' },
    { name: 'tek' },
    { name: 'tronderbladet' },
    { name: 'vestlandsnytt' },
    { name: 'vigga' },
    { name: 'vikebladet' },
    { name: 'vg.no' },
    { name: 'vol' },
];

export function Channels() {
    return (
        <div className="grid grid-cols-6 gap-x-12 gap-y-8">
            {balls.map(({ name }) => {
                const { logo: Logo } = channelConfig(name);
                if (!Logo) return null;
                return <Logo className="channel" key={name} />;
            })}
        </div>
    );
}
